import copyLinkToClipboard from '@/js/utils/copy-link-to-clipboard';
const blockSocialLinks = () => {
  const blockSocialLink = document.querySelectorAll('.block-social-link');
  if (!blockSocialLink) return;
  copyLinkToClipboard();
  var toggleButton = document.getElementById('accordion-toggle');
  var content = document.getElementById('accordion-content');

  toggleButton?.addEventListener('click', function () {
    content?.classList.toggle('active');
  });
};

export default blockSocialLinks;
